<div class="card audit-card">
  <div class="header-information inline-editing-box" *ngIf="isBeingEdited(check) && !isInlineEditingMessage">
    <div #editedBox class="edited-box mr-2">
      <img class="mr-4 image-edit" src="assets/icons/info-blue.svg"/>
      <p class="m-0 edit-text">{{ 'CHECK.INSPECTION_EDITED_BY' | translate }} <b>{{ check.editedByUsername }}</b>.</p>
    </div>
  </div>
  <div class="card-header">
    <div class="card-header-info">
      <div class="text-detail mb-3">{{ check.creationDate | dateCheckFormatter }} | {{ 'CHECK.CREATED_BY' | translate }} {{ check.username }}</div>
      <div class="text-title"> {{ check.institutionName }} </div>
      <div class="text-subtitle">{{ check.wardName }} | {{ translateText(check.departmentName) }} </div>
    </div>
    <div class="d-flex">
      <div class="card-header-buttons">
        <div class="header-information">
          <div #editedBox class="edited-box mr-2" *ngIf="isBeingEdited(check) && isInlineEditingMessage">
            <img class="mr-4 image-edit" src="assets/icons/info-blue.svg"/>
            <p class="m-0 edit-text">{{ 'CHECK.INSPECTION_EDITED_BY' | translate }} <b>{{ check.editedByUsername }}</b>.</p>
          </div>
  
          <button *ngIf="check.isCompleted" type="button" class="btn btn-rounded-success">{{ 'CHECK.COMPLETED' | translate
            }}</button>
          <button *ngIf="!check.isCompleted" type="button" class="btn btn-rounded-warning">{{ 'CHECK.IN_PROCESS' | translate
            }}</button>
        </div>
        <div class="buttons-edit">
          <button *ngIf="isBeingEdited(check)" type="button" class="btn btn-square-responsive"
            (click)="goToViewHygieneCheck(check.id)">
            <img class="icon" src="assets/icons/viewOutlined.svg" />
          </button>

          <button *ngIf="!check.isCompleted" type="button" class="btn btn-square-responsive btn-edit"
            (click)="goToHygieneCheck(check.id)" [disabled]="isBeingEdited(check)">
            <img class="icon" src="assets/icons/editBlueOutlined.svg" />
            <span class="d-none d-md-block">{{ 'CHECK.CONTINUE' | translate }}</span>
          </button>

          <button *ngIf="check.isCompleted" type="button" class="btn btn-square-responsive"
            data-toggle="modal" data-target="#downloadModal" (click)="downloadCheck(check)">
            <img class="icon" src="assets/icons/downloadOutlined.svg" />
          </button>

          <button type="button" class="btn btn-square-responsive" (click)="deleteCheck(check.id)" [disabled]="isBeingEdited(check)">
            <img class="icon" src="assets/icons/trashOutlined.svg" />
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="card-body-info d-flex justify-content-between">

      <div class="info-data d-none d-md-flex">
        <label class="info-data-title">{{ 'CHECK.MODIFIED_BY' | translate }}</label>
        <label class="info-data-detail">{{ check.updatedByUsername }} | {{ check.modificationDate | dateCheckFormatter }}</label>
      </div>
      <div class="info-data d-none d-md-flex">
        <label class="info-data-title">{{ 'CHECK.ADDITIONAL_PARTICIPANT' | translate }}</label>
        <label class="info-data-detail">{{check.furtherParticipant}}</label>
      </div>

      <div class="info-data info-data-web">
        <label class="info-data-title">{{ 'CHECK.CHECK_DESCRIPTION' | translate }}</label>
        <div class="info-data-detail info-data-description">
          <div><span>{{check.totalQuestions}}</span> {{ 'CHECK.TOTAL_QUESTION' | translate }}</div>
          <div><span>{{getSolvedQuestions(check)}}</span> {{ 'CHECK.SOLVED_QUESTIONS' | translate }}</div>
          <div>
            <span>
              <img src="assets/icons/cameraOutlined.svg" />
            </span>
            {{check.stationAuditsCount}}
          </div>
        </div>
      </div>
    </div>

    <div class="collapse d-md-none" [id]="'checkCollapseInfo-'+position">
      <div class="info-data mb-24">
        <label class="info-data-title">{{ 'CHECK.CHECK_OWNER' | translate }}</label>
        <label class="info-data-detail">{{ getUserName() }}</label>
      </div>
      <div class="info-data mb-16">
        <label class="info-data-title">{{ 'CHECK.ADDITIONAL_PARTICIPANT' | translate }}</label>
        <label class="info-data-detail">{{check.furtherParticipant}}</label>
      </div>
    </div>

    <button class="btn btn-collapse d-md-none" type="button" data-bs-toggle="collapse"
      [attr.data-bs-target]="'#checkCollapseInfo-'+position" aria-expanded="false"
      [attr.aria-controls]="'checkCollapseInfo-'+position" (click)="openCollapse = !openCollapse">
      {{ openCollapse ? ('CHECK.SHOW_LESS' | translate) : ('CHECK.SHOW_MORE' | translate) }}
      <img [src]=" openCollapse ? 'assets/icons/chevronUpOutlined.svg' : 'assets/icons/chevronDownOutlined.svg'" />
    </button>

  </div>
</div>
